import { cva } from '@/styled-system/css';

export const tableRowRecipe = cva({
  base: {
    verticalAlign: 'top',
  },
  compoundVariants: [
    {
      interactive: true,
      selected: false,
      css: {
        _hover: {
          '& > td, & > th': {
            backgroundColor: 'bg.action.neutral.alt.hover',
            color: 'text.neutral',
          },
        },
        _active: {
          '& > td, & > th': {
            backgroundColor: 'bg.action.neutral.alt.pressed',
            color: 'text.neutral',
          },
        },
      },
    },
  ],
});
